export const cayanDefaultState = {
  terminalIP: '',
  terminalPort: '8080',
  secureDeviceConnection: '0',
  merchantName: '',
  merchantSiteID: '',
  merchantKey: '',
};

export const cayanFields = {
  pos: {
    deviceIPOrHost: {
      id: 'deviceIPOrHost',
      title: 'Device IP',
      type: 'text',
      validate: (val) => (val?.length ? null : 'Field is required'),
    },
    secureDeviceConnection: {
      id: 'secureDeviceConnection',
      title: 'Device Secure Connection',
      type: 'checkbox',
    },
  },
  account: {
    merchantName: {
      id: 'merchantName',
      title: 'Merchant Name',
      type: 'text',
      validate: (val) => (val?.length ? null : 'Field is required'),
    },
    merchantSiteID: {
      id: 'merchantSiteID',
      title: 'Merchant Site ID',
      type: 'text',
      validate: (val) => (val?.length ? null : 'Field is required'),
    },
    merchantKey: {
      id: 'merchantKey',
      title: 'Merchant Key',
      type: 'text',
      validate: (val) => (val?.length ? null : 'Field is required'),
    },
  },
};
